import { Person, Sex } from '../types/form';

export function getEmail(person:Person): string {
  return person.sex === Sex.FEMALE ? 'janina.kowalska@zhp.pl' : 'jan.kowalski@zhp.pl';
}
